import React, { useEffect } from 'react';
import logo from './logo.png';
import './home.css';
import { useHistory } from 'react-router-dom';

const HomePage = () => {
  const history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem('user')) {
      history.push('/login');
    }
  }, [history]);

  const logOut = () => {
    localStorage.clear();
    history.push('/login');
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="logo" alt="logo femurn" />
        <div className="logout" onClick={logOut}>
          Sair
        </div>
      </header>
      <div className="container">
        <iframe
          title="Femurn"
          className="embbed"
          src="https://app.powerbi.com/view?r=eyJrIjoiY2ExYWJmZmQtNmM0Ni00MmNmLWFlYTMtOTkyNmZmNmUwZWU2IiwidCI6IjQ5OWFiMmZiLWYzZjktNDdjNi04MzlhLWUyNzVhNDBhN2RmYiJ9&pageName=ReportSectiondbb0dbeb09ee80c066a6"
          frameBorder="0"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
};

export default HomePage;
